import { render, staticRenderFns } from "./CartTotalRow.vue?vue&type=template&id=45157c35"
import script from "./CartTotalRow.vue?vue&type=script&lang=js"
export * from "./CartTotalRow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports